// sagaStatusActions.js
export const RESET_SAGAS = 'RESET_SAGAS'

export const resetSagas = () => ({ type: RESET_SAGAS })
